export default __webpack_public_path__ + "static/media/logo.a933ec5e.png";